import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[NumberInputOnly]',
  standalone: true,
})
export class NumberInputOnlyDirective {
  constructor() {}

  @HostListener('keydown', ['$event'])
  onKeyDown(e) {
    if ([69, 109, 107, 110, 187, 189].includes(e.keyCode)) {
      e.preventDefault();
    }
  }

  @HostListener('keydown.arrowup', ['$event'])
  @HostListener('keydown.arrowdown', ['$event'])
  arrowUp(e) {
    e.preventDefault();
  }
}
